module.exports = __webpack_public_path__ + "static/media/icon_checkout.8308672d.png";